import { ArgentoInsurancePaymentPeriodicities, type ProductPlanSumary } from '~/config'

export type Coverage = Nullable<{
  grandTotal: number
  argentoInsurancePlanId: string
  planCode: string
  planName: string
  details: ProductPlanSumary
  argentoInsuranceId: number
  avaliablePromotionalCode: boolean
  argentoInsuranceProductId: number
  argentoInsuranceProductName: string
  argentoInsuranceCompanyId: number
  argentoInsuranceInsuredAmountId: number
  argentoInsuranceCoverageRequestData?: SiteApiSchema<'TarificadorRQViewModel'>
  argentoInsuranceAplicablePaymentConditions?: SiteApiSchema<'ProductoCondicionPagoModel'>[]
  argentoInsuranceAplicableCalculatedPaymentConditions?: SiteApiSchema<'TarificadorCondicionPagoCalculoModel'>[]
}>

function load(model?: Partial<Coverage> | null): Coverage {
  return {
    argentoInsuranceId: model?.argentoInsuranceId ?? null,
    argentoInsuranceInsuredAmountId: model?.argentoInsuranceInsuredAmountId ?? null,
    grandTotal: model?.grandTotal ?? null,
    avaliablePromotionalCode: model?.avaliablePromotionalCode ?? false,
    argentoInsuranceProductId: model?.argentoInsuranceProductId ?? null,
    argentoInsuranceProductName: model?.argentoInsuranceProductName ?? null,
    argentoInsurancePlanId: model?.argentoInsurancePlanId ?? null,
    planCode: model?.planCode ?? null,
    planName: model?.planName ?? null,
    details: model?.details ?? null,
    argentoInsuranceCompanyId: model?.argentoInsuranceCompanyId ?? null,
    argentoInsuranceCoverageRequestData: model?.argentoInsuranceCoverageRequestData ?? null,
    argentoInsuranceAplicablePaymentConditions:
      model?.argentoInsuranceAplicablePaymentConditions ?? null,
    argentoInsuranceAplicableCalculatedPaymentConditions:
      model?.argentoInsuranceAplicableCalculatedPaymentConditions ?? null,
  }
}

function getPeriodicityList() {
  const { RemoteConfigurationStore } = stores()
  const enumList = Object.values(ArgentoInsurancePaymentPeriodicities)
  if (RemoteConfigurationStore.value?.form?.frecuenciaPago) {
    const configList = RemoteConfigurationStore.value?.form?.frecuenciaPago.split(',')
    const _default = enumList.find((item) => sanitize(item.text) === sanitize(configList[0]))

    return {
      list: enumList.filter((item) => configList.map(sanitize).includes(sanitize(item.text))),
      default: configList.every((i) => sanitize(i) === sanitize(_default?.text))
        ? _default
        : undefined,
    }
  }
  return { list: enumList }
}

export const Coverage = {
  load,
  getPeriodicityList,
}
